import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_PASSWORD } from "../../config/admin";
import { toast } from "sonner";

const AdminLogin = () => {
  
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("isAdmin") === "true") {
      navigate("/admin");
    }
  }, [navigate]);
  const handleLogin = () => {
    if (!password) return;

    if (password === ADMIN_PASSWORD) {
      localStorage.setItem("isAdmin", "true");
      toast.success("Welcome back, Admin");
      navigate("/admin");
    } else {
      toast.error("Incorrect admin password");
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h2 style={styles.title}>Admin Access</h2>
        <p style={styles.subtitle}>Enter the admin password to continue</p>

        <input
          type="password"
          placeholder="Admin password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleLogin()}
          style={styles.input}
        />

        <button
          onClick={handleLogin}
          disabled={!password}
          style={{
            ...styles.button,
            opacity: password ? 1 : 0.6,
            cursor: password ? "pointer" : "not-allowed",
          }}
        >
          Login
        </button>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f4f6f8",
  },
  card: {
    width: "100%",
    maxWidth: "380px",
    padding: "32px",
    borderRadius: "10px",
    background: "#fff",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },
  title: {
    marginBottom: "6px",
    textAlign: "center",
    fontSize: "22px",
  },
  subtitle: {
    marginBottom: "20px",
    textAlign: "center",
    color: "#666",
    fontSize: "14px",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "16px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    outline: "none",
    fontSize: "14px",
  },
  button: {
    width: "100%",
    padding: "12px",
    borderRadius: "6px",
    border: "none",
    background: "#111",
    color: "#fff",
    fontSize: "15px",
    fontWeight: "600",
  },
};

export default AdminLogin;
